import { css } from '@emotion/react'
import { graphql, useStaticQuery } from 'gatsby'
import { ComponentPropsWithoutRef, useState } from 'react'

import { mq } from '@/theme/mixins'
import { colors } from '@/theme/variables'

import { AlumnaeArticleFeaturedThumbnail } from '../AlumnaeArticleThumbnail/AlumnaeArticleFeaturedThumbnail'
import { AlumnaeArticleThumbnail } from '../AlumnaeArticleThumbnail/AlumnaeArticleThumbnail'

interface Props extends ComponentPropsWithoutRef<'section'> {
  featuredArticle?: Queries.AlumnaeArticleFeaturedThumbnailFragment | null
}

export const AlumnaeArticlesSection = ({
  featuredArticle,
  ...props
}: Props): JSX.Element => {
  const { allDatoCmsAlumnaeArticle } =
    useStaticQuery<Queries.AlumnaeArticlesSectionQuery>(graphql`
      query AlumnaeArticlesSection {
        allDatoCmsAlumnaeArticle(sort: { meta: { createdAt: DESC } }) {
          nodes {
            ...AlumnaeArticleThumbnail
          }
        }
      }
    `)
  const nonFeaturedArticles = allDatoCmsAlumnaeArticle.nodes.filter(
    article => article?.id !== featuredArticle?.id
  )
  const [loadCount, setLoadCount] = useState(24)

  const styles = {
    section: css`
      background: #fff;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: var(--gtr-36);
      grid-row-gap: var(--row-54);
      padding: var(--row-36) var(--margin) var(--row-108);
      ${mq().m} {
        grid-template-columns: 1fr 1fr;
      }
      ${mq().s} {
        grid-template-columns: 1fr;
      }
    `,
    showMoreButton: css`
      grid-column: 1 / -1;
      justify-self: center;
      color: ${colors.gray45};
      text-transform: uppercase;
      font-size: var(--fs-18);
      border: 2px currentColor solid;
      padding: 0.5em 0.75em;
      font-weight: 500;
      @media (hover: hover) {
        &:hover {
          color: ${colors.red};
        }
      }
    `,
  }
  return (
    <section
      css={styles.section}
      {...props}
    >
      <AlumnaeArticleFeaturedThumbnail data={featuredArticle} />
      {nonFeaturedArticles.slice(0, loadCount).map(article => (
        <AlumnaeArticleThumbnail
          data={article}
          key={article.id}
        />
      ))}
      {loadCount < nonFeaturedArticles.length && (
        <button
          css={styles.showMoreButton}
          onClick={() => setLoadCount(prev => prev + 24)}
        >
          Load More
        </button>
      )}
    </section>
  )
}
